import { useFormContext } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";

export default function Service() {
  const { control } = useFormContext();

  return (
    <div className="relative">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4">
          <FormField
            control={control}
            name="service"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="flex flex-row justify-between items-center gap-2">
                  Please enter the service you'll perform
                  <FormMessage />
                </FormLabel>
                <FormControl>
                  <Input
                    value={field.value ?? ""}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={control}
            name="notes_service"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Service Notes</FormLabel>
                <FormControl>
                  <Textarea
                    rows={6}
                    value={field.value ?? ""}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
      </div>
    </div>
  );
}
